import { APP_DATE_FORMATS } from '../shared/shared.module';
var ɵ0 = APP_DATE_FORMATS;
var ChatQuizModule = /** @class */ (function () {
    function ChatQuizModule() {
    }
    return ChatQuizModule;
}());
export { ChatQuizModule };
export { ɵ0 };
